// extracted by css-extract-rspack-plugin
export default {"projectCodes":"OAASCI8YzE_jTcrI","alertText":"JxK7mu85AgyMGIi9","container":"Aa8IZalGYrkAx3Ks"};